import React, { useEffect } from "react";
import FormikWrapper from "../../../../FormikWrapper";
import { loginSchema } from "../../../../../formValidation";
import Loader from "../../../../Loader";
import FormInput from "../../../../FormInput";
// import AppleButton from "../ThirdParty/AppleAuth";
// import FacebookButton from "../ThirdParty/FacebookAuth";
// import GoogleButton from "../ThirdParty/GoogleAuth";
import Password from "../../../../Password";
import { useDispatch, useSelector } from "react-redux";
import { customerLogin } from "../../../../../redux/actions/customer/authAction";
import { AppDispatch } from "../../../../../redux/store";
import { ILogin } from "../../../../../types/auth";
// import { useNavigate } from "react-router-dom";
// import { USER_ROUTES } from "../../../../../constants/appRoutes";
import { RootState } from "../../../../../redux/reducers/allReducers";
import useFirebaseToken from "../../../../../hooks/useFirebaseToken";

interface CustomerLoginProps {
  closeModal: CallableFunction;
  handleForgotPasswordModal: () => void;
  handleVerificationPopup: CallableFunction;
}

const CustomerLogin: React.FC<CustomerLoginProps> = ({
  closeModal,
  handleForgotPasswordModal,
  handleVerificationPopup,
}) => {
  const initialValues: ILogin = {
    email: "",
    password: "",
  };

  const notificationToken = useFirebaseToken();

  // const navigate = useNavigate();
  const { loading, userInfo } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (userInfo) {
      // navigate(USER_ROUTES.ROOT);
      closeModal();
    }
  }, [userInfo]);

  const dispatch: AppDispatch = useDispatch();

  const handleOnSubmit = (values: any) => {
    const data = {
      ...values,
      email: values?.email?.trim()?.toLowerCase(),
      device_type: "web",
      device_token: notificationToken?.token ?? "",
    };
    dispatch(customerLogin({ data, callback: handleVerificationPopup }));
  };

  return (
    <div className="w-full">
      <FormikWrapper
        initialValues={initialValues}
        validationSchema={loginSchema}
        onSubmit={handleOnSubmit}
        buttonProps={{
          children: loading ? (
            <Loader size="small" />
          ) : (
            <span className="py-1 text-2xl font-bold">Sign In</span>
          ),
          className: "w-full mt-8",
          isDisabled: loading,
        }}
      >
        <FormInput
          label="Email / Phone Number"
          name="email"
          placeholder="Enter Email or Phone Number"
          required
        />
        <Password
          label="Password"
          name="password"
          placeholder="Enter Password"
          required
        />
      </FormikWrapper>

      <div className="flex justify-center items-center py-3">
        <button
          type="button"
          className="text-primary text-base font-bold text-center w-fit"
          onClick={handleForgotPasswordModal}
        >
          Forgot your password?
        </button>
      </div>

      {/* <div className="py-6 border-t-2 border-t-black px-4 space-y-6">
        <h3 className="text-center font-normal text-lg">Or connect with:</h3>

        <AppleButton />
        <FacebookButton />
        <GoogleButton />
      </div> */}
    </div>
  );
};

export default CustomerLogin;
